// Standard regex variables
export const numbericRegex = /^[0-9]*$/;
export const alphaRegex = /^[a-zA-Z ]*$/;
export const alphaNumbericRegex = /^[a-zA-Z0-9]*$/;
export const webSiteRegex =
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
export const emailIdRegex =
  /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,9})$/;
export const fullNameRegex = /^[a-zA-Z]+ [a-zA-Z]*$/;
export const passwordRegex =
  /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const driversLicenseRegex = /^[A-Z0-9]{1,12}$/;
export const usPassportRegex = /^[0-9]{9}$/;
